// extracted by mini-css-extract-plugin
export default {"image404Wrapper":"PageContent404__image404Wrapper-UzSvI","image404":"PageContent404__image404-STC28","header":"PageContent404__header-Kc60x","text":"PageContent404__text-D9464"};